import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Dropdown, Menu, Checkbox, Select } from "antd";
import { ReactComponent as ColumnList } from "../../image/ColumnList.svg";
import {
  Space,
  DatePicker,
  Table,
  Tooltip,
  Input,
  Form,
  Col,
  Popconfirm,
  Row,
  Button,
  Popover,
  Breadcrumb,
} from "antd";
import ButtonField from "../../common/htmlComponents/ButtonField";
import {
  EyeOutlined,
  DownloadOutlined,
  ClockCircleOutlined,
  FilterOutlined,
  UndoOutlined,
  PieChartOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import SearchIcon from "../../image/SearchIcon.svg";
import { ReactComponent as Archiveicon } from "../../image/Archiveicon.svg";
import RefreshIcon from "../../image/refreshIcon.svg";
import { getRequest, postRequest } from "../../axios";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import { ReactComponent as Archive } from "../../image/Archive.svg";
import { authUserData } from "../../utils/Helper";
import { debounce } from "lodash";
import moment from "moment";
import OrderApprove from "../../image/OrderApprove.svg";
import PendingActions from "../../image/PendingActions.svg";
import rejectedIcon from "../../image/rejectedIcon.svg";
import arrow1 from "../../image/arrow5.svg";
import TotalCount from "../../image/TotalCount.svg";
import DotStatus from "./DotStatus";
import "jspdf-autotable";
import jsPDF from "jspdf";
import SiteApprovalDotStatus from "./SiteApprovalDotStatus";
import SubscriptionNotification from "../../authentication/SubscriptionNotification";

const PurchaseRequisitionHistory = () => {
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
  });
  const { t } = useTranslation();
  const [purchaseRequisitionHistory, setPurchaseRequisitionHistory] = useState(
    []
  );
  const [poOrderPlaced, setPoOrderPlaced] = useState("");
  const [prStatus, setPrStatus] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalCount, settotalCount] = useState(0);
  const CompanyID = authUserData()?.company ? authUserData()?.company : null;
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const [categoryTree, setCategoryTree] = useState([]);
  const [categoryTreeFilter, setCategoryTreeFilter] = useState("");
  const [selectedPrNumber, setSelectedPrNumber] = useState(null);
  const [zoneList, setZoneList] = useState([]);
  const [pODataId, setPODataId] = useState(null);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [selectedCard, setSelectedCard] = useState(null);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [statusCounts, setStatusCounts] = useState({
    approve_count: 0,
    pending_for_approval_count: 0,
    reject_count: 0,
    total_count: 0,
    rfq_to_be_floted_count: 0,
  });
  const formRef = useRef();
  const [totalRequest, setTotalRequest] = useState(null);
  const [dotLoaded, setDotLoaded] = useState(false);
  const [clickedFilterButton, setClickedFilterButton] = useState(false);
  const navigate = useNavigate();

  const [filterDate, setFilterDate] = useState([
    "2D",
    "3D",
    "5D",
    "7D",
    "1M",
    "All",
  ]);

  const [selectedFilter, setSelectedFilter] = useState("5D");

  const isCompanyAdmin = authUserData()?.role?.some(
    (role) => role.name === "Company Admin"
  );
  const hasCompanyRole = authUserData()?.company_role === "Company Admin";
  const [checkedList, setCheckedList] = useState([
    "category_tree_name",
    "pr_number",
    "pr_created_date",
    "pr_status",
    "pr_status_for_rfq",
    "operation",
    "pr_approval_by",
    "pr_creator",
  ]);
  useEffect(() => {
    const getStatusCount = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          `purchase-requisition/pr-status-count/?company_id=${CompanyID}`
        );
        if (apiResponse.data.success) {
          const message = apiResponse.data.data;
          setStatusCounts({
            approve_count: message.approve_count,
            pending_for_approval_count: message.pending_for_approval_count,
            reject_count: message.reject_count,
            total_count: message.total_count,
            rfq_to_be_floted_count: message.rfq_to_be_floted_count,
          });
        } else {
          ErrorNotificationMsg(t("error_in_requested_demo_list_status_count"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getStatusCount();

    const getCategoryTree = async () => {
      try {
        const response = await getRequest("category-tree/?no_pagination=True");
        setCategoryTree(response.data.data || []);
      } catch (error) {
        setCategoryTree([]);
      }
    };
    getCategoryTree();
  }, []);

  const handleRefresh = async () => {
    setSelectedFilter("All");
    setSelectedCard(null);
    setState((prevState) => {
      const {
        pr_created_date__gte,
        pr_created_date__lte,
        pr_status,
        search,
        ...rest
      } = prevState;
      return {
        ...rest,
        page: 1,
        pagesize: 10,
        ordering: "id",
        pr_created_date__gte: "",
        pr_created_date__lte: "",
      };
    });
    formRef.current.setFieldsValue({
      pr_created_date__gte: null,
      pr_status: null,
      po_order_placed: null,
      pr_created_date__lte: null,
    });
  };

  const handleApplyFilter = () => {
    setSelectedCard(null);
    setClickedFilterButton(true);
    const filterParams = {
      pr_created_date__gte: startDate,
      pr_created_date__lte: endDate,
      po_order_placed: poOrderPlaced,
      pr_status: prStatus,
      category_id: categoryTreeFilter,
    };
    setState(filterParams);
  };

  const handleCategoryChange = (value) => {
    setCategoryTreeFilter(value);
  };

  const getPastDate = (days) => {
    const date = new Date();
    date.setDate(date.getDate() - days);
    return date;
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const shortYear = year % 100;
    return `${day}-${month}-${shortYear}`;
  };

  const dayMapping = {
    "2D": 1,
    "3D": 2,
    "5D": 4,
    "7D": 6,
    "1M": 29,
    All: 730,
  };

  const applyFilter = (item) => {
    if (dayMapping[item] !== undefined) {
      const startDate = formatDate(getPastDate(dayMapping[item]));
      const endDate = formatDate(new Date());

      const filterParams = {
        pr_created_date__gte: startDate,
        pr_created_date__lte: endDate,
        // pr_status: selectedCard
      };

      setState(filterParams);
    }
  };

  const handleStartDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");
    setStartDate(formattedDate);
  };

  const handleEndDateChange = (date) => {
    const formattedDate = moment(date).format("DD-MM-YY");

    setEndDate(formattedDate);
  };

  const { Search } = Input;
  function parseCSV(data) {
    const lines = data.trim().split("\n");
    const headers = lines[0].split(",");
    return lines.slice(1).map((line) => {
      const values = line.split(",");
      return headers.reduce((obj, header, index) => {
        obj[header.trim()] = values[index].trim();
        return obj;
      }, {});
    });
  }

  const handleDownload = async (prNumber, pr) => {
    try {
      const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
      const response = await getRequest(endpoint);

      if (!response?.data?.data) {
        console.error("No data received from API");
        return;
      }

      const parsedData = Array.isArray(response.data.data)
        ? response.data.data
        : [];
      const parsedData1 = Array.isArray(response.data.approval_by_site)
        ? response.data.approval_by_site
        : [];

      if (!parsedData.length) {
        console.error("No valid data to generate PDF.");
        return;
      }

      const pdf = new jsPDF("p", "pt", "a4");

      pdf.setFillColor(255, 255, 255); // Light gray
      pdf.rect(
        0,
        0,
        pdf.internal.pageSize.width,
        pdf.internal.pageSize.height,
        "F"
      );

      pdf.setFont("times");
      pdf.setFontSize(14);
      pdf.text("Purchase Requisition Report", 200, 40);

      const prCreatedDate = parsedData1[0]?.pr_created_date || "N/A";

      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(12);
      pdf.text(`PR Number: ${pr}`, 50, 75);

      const pageWidth = pdf.internal.pageSize.width;

      pdf.setTextColor(0, 0, 0);
      pdf.setFontSize(12);

      const textWidth = pdf.getTextWidth(`PR Created Date: ${prCreatedDate}`);
      pdf.text(
        `PR Created Date: ${prCreatedDate}`,
        pageWidth - textWidth - 50,
        75
      );

      const materialColumns = [
        "Sr. No.",
        "City",
        "Site",
        "Item",
        "Quantity",
        "Preferred UoM.",
        "Qty. in Kg",
        "Est. Amount",
      ];
      const materialRows = [];
      let grandTotal = 0; // Grand total for all sites
      let serialNumber = 1; // Serial number counter

      parsedData.forEach((data) => {
        data.site_wise_pr.forEach((site, siteIndex) => {
          let siteTotal = 0;
          site.pr_material_details.forEach((item, index) => {
            const estimatedAmount =
              item.pr_material_type_quantity_by_kg !== 0
                ? item.estimated_material_unit_price *
                  item.pr_material_type_quantity_by_kg
                : item.estimated_material_unit_price *
                    item.pr_material_type_quantity || 0;
            siteTotal += estimatedAmount;
            grandTotal += estimatedAmount;

            materialRows.push([
              siteIndex === 0 && index === 0 ? serialNumber++ : "", // Increment serial number
              siteIndex === 0 && index === 0 ? data.city_name : "", // Show city name only once
              index === 0 ? site.site_name : "",
              item.pr_material_type_name,
              item.pr_material_type_quantity.toLocaleString("en-IN"),
              item.pr_material_type_uom_id === "Cubic Meter"
                ? "Cu. Mtr."
                : item.pr_material_type_uom_id,
              item.pr_material_type_quantity_by_kg.toLocaleString("en-IN"),
              `${estimatedAmount.toLocaleString()}`,
            ]);
          });

          materialRows.push([
            "", // Empty Sr. No.
            "", // Empty City
            {
              content: `Sub Total for ${site.site_name}`,
              colSpan: 5,
              styles: { halign: "right", fontStyle: "bold" },
            },
            {
              content: `${siteTotal.toLocaleString()}`,
              styles: { fontStyle: "bold" },
            },
          ]);
        });
      });

      materialRows.push([
        "",
        "",
        {
          content: "Total",
          colSpan: 5,
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: `${grandTotal.toLocaleString()}`,
          styles: { fontStyle: "bold", halign: "right" },
        },
      ]);

      if (materialRows.length) {
        pdf.autoTable({
          head: [materialColumns],
          body: materialRows,
          startY: 100,
          theme: "grid",
          styles: {
            halign: "center",
            textColor: [0, 0, 0],
            fontSize: 10, // Adjust font size
            cellPadding: 5, // Proper spacing
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          columnStyles: {
            0: { cellWidth: 28 }, // Sr. No.
            1: { cellWidth: 65 }, // City
            2: { cellWidth: 70 }, // Site
            3: { cellWidth: 80 }, // Item
            4: { cellWidth: 50, halign: "right" }, // Quantity
            5: { cellWidth: 70 }, // Preferred UoM
            6: { cellWidth: 60, halign: "right" }, // Qty. in Kg
            7: { cellWidth: 90, halign: "right" }, // Est. Amount
          },
        });
      } else {
        pdf.text("No material data available.", 40, 120);
      }

      pdf.setFont("times", "bold");
      pdf.setFontSize(14);
      pdf.text("PR Approval Status:", 40, pdf.autoTable.previous.finalY + 35); // Add some space before table

      const approvalColumns = [
        "City",
        "Site",
        "Approver",
        "Role",
        "Status",
        "Sent For Approval",
        "Approved Date",
        "Approval Time",
      ];

      const approvalRows = parsedData1.map((data) => [
        data.city_name || "N/A",
        data.site_name || "N/A",
        data.pr_approval_by || "N/A",
        (Array.isArray(data.pr_approval_by_role)
          ? data.pr_approval_by_role.map((role) => role.role_name)
          : ["N/A"]
        ).join(", "),
        data.pr_status || "Pending",
        data.pr_sent_for_approval_date || "-",
        data.pr_approval_date || "-",
        data.approval_time || "-",
      ]);

      if (approvalRows.length) {
        pdf.autoTable({
          head: [approvalColumns],
          body: approvalRows,
          startY: pdf.autoTable.previous.finalY + 50,
          theme: "grid",
          styles: {
            halign: "center",
            fontSize: 10,
            cellPadding: 6,
            textColor: [0, 0, 0],
            lineWidth: 0.5,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          alternateRowStyles: { fillColor: [255, 255, 255] },
          columnStyles: {
            0: { cellWidth: 70 },
            1: { cellWidth: 80 },
            2: { cellWidth: 80, halign: "right" },
          },
        });
      } else {
        pdf.text(
          "No approval data available.",
          40,
          pdf.autoTable.previous.finalY + 50
        );
      }
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.text(
          `Page ${i} of ${totalPages}`,
          pdf.internal.pageSize.width - 80,
          pdf.internal.pageSize.height - 30
        );
      }

      pdf.save(`purchase_requisition_${pr}.pdf`);
    } catch (error) {
      console.error("Error downloading PR:", error);
    }
  };

  const handleDownloadForSteel = async (prNumber, pr) => {
    try {
      const endpoint = `purchase-requisition/${prNumber}/download-single-pr-history-excel/`;
      const response = await getRequest(endpoint);

      if (!response?.data?.data) {
        console.error("No data received from API");
        return;
      }

      const parsedData = Array.isArray(response.data.data)
        ? response.data.data
        : [];
      const parsedData1 = Array.isArray(response.data.approval_by_site)
        ? response.data.approval_by_site
        : [];

      if (!parsedData.length) {
        console.error("No valid data to generate PDF.");
        return;
      }

      const pdf = new jsPDF("landscape", "pt", "a4");
      const pageWidth = pdf.internal.pageSize.width;

      // PDF Title
      pdf.setFillColor(255, 255, 255);
      pdf.rect(0, 0, pageWidth, pdf.internal.pageSize.height, "F");
      pdf.setFont("times");
      pdf.setFontSize(14);
      pdf.text("Purchase Requisition Report", pageWidth / 2 - 100, 40);

      const prCreatedDate = parsedData1[0]?.pr_created_date || "N/A";
      pdf.setFontSize(12);
      pdf.setTextColor(0, 0, 0);
      pdf.text(`PR Number: ${pr}`, 50, 75);
      const textWidth = pdf.getTextWidth(`PR Created Date: ${prCreatedDate}`);
      pdf.text(
        `PR Created Date: ${prCreatedDate}`,
        pageWidth - textWidth - 50,
        75
      );

      // === Capitalize diameter labels ===
      const allDiameters = new Set();
      parsedData.forEach((data) => {
        data.site_wise_pr?.forEach((site) => {
          site.pr_material_details?.forEach((item) => {
            item.steel_sizes?.forEach((size) => {
              const value = `${size.value}${(
                size.diameter_uom || ""
              ).toUpperCase()}`;
              allDiameters.add(value);
            });
          });
        });
      });

      const sortedDiameters = Array.from(allDiameters).sort(
        (a, b) => parseInt(a) - parseInt(b)
      );

      const materialColumns = [
        "Sr. No.",
        "City",
        "Site",
        "Grade & Quality",
        ...sortedDiameters,
        "Preferred UoM.",
        "Qty. in Kg",
        "Est. Amount",
      ];

      const materialRows = [];
      let grandTotal = 0;
      let serialNumber = 1;

      parsedData.forEach((data) => {
        data.site_wise_pr?.forEach((site, siteIndex) => {
          let siteTotal = 0;

          site.pr_material_details?.forEach((item, index) => {
            const estimatedAmount =
              item.pr_material_type_quantity_by_kg !== 0
                ? item.estimated_material_unit_price *
                  item.pr_material_type_quantity_by_kg
                : item.estimated_material_unit_price *
                    item.pr_material_type_quantity || 0;

            siteTotal += estimatedAmount;
            grandTotal += estimatedAmount;

            const diameterMap = {};
            item.steel_sizes?.forEach((size) => {
              const key = `${size.value}${(
                size.diameter_uom || ""
              ).toUpperCase()}`;
              diameterMap[key] = (diameterMap[key] || 0) + size.quantity;
            });

            const diameterQuantities = sortedDiameters.map(
              (dia) => diameterMap[dia]?.toLocaleString("en-IN") || "N/A"
            );

            materialRows.push([
              siteIndex === 0 && index === 0 ? serialNumber++ : "",
              siteIndex === 0 && index === 0 ? data.city_name : "",
              index === 0 ? site.site_name : "",
              item.pr_material_type_name || "-",
              ...diameterQuantities,
              item.pr_material_type_uom_id === "Cubic Meter"
                ? "Cu. Mtr."
                : item.pr_material_type_uom_id,
              item.pr_material_type_quantity_by_kg?.toLocaleString("en-IN") ||
                "0",
              estimatedAmount.toLocaleString("en-IN"),
            ]);
          });

          materialRows.push([
            "",
            "",
            {
              content: `Sub Total for ${site.site_name}`,
              colSpan: 4 + sortedDiameters.length,
              styles: { halign: "right", fontStyle: "bold" },
            },
            {
              content: `${siteTotal.toLocaleString("en-IN")}`,
              styles: { fontStyle: "bold", halign: "right" },
            },
            "",
            "",
          ]);
        });
      });

      materialRows.push([
        "",
        "",
        {
          content: "Total",
          colSpan: 4 + sortedDiameters.length,
          styles: { halign: "right", fontStyle: "bold" },
        },
        {
          content: `${grandTotal.toLocaleString("en-IN")}`,
          styles: { fontStyle: "bold", halign: "right" },
        },
        "",
        "",
      ]);

      // === Dynamic Column Widths ===
      let materialTableY = 100;
      let tableEndY = materialTableY;
      const totalColumns = materialColumns.length;
      const leftRightMargin = 40;
      const usableWidth = pageWidth - leftRightMargin * 2;
      const dynamicColWidth = Math.floor(usableWidth / totalColumns);

      const columnStyles = {};
      for (let i = 0; i < totalColumns; i++) {
        columnStyles[i] = { cellWidth: dynamicColWidth };
      }

      // === Generate Table ===
      if (materialRows.length) {
        pdf.autoTable({
          head: [materialColumns],
          body: materialRows,
          startY: materialTableY,
          theme: "grid",
          styles: {
            fontSize: 9,
            halign: "center",
            textColor: [0, 0, 0],
            cellPadding: 3,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          columnStyles,
          didDrawPage: function (data) {
            tableEndY = data.cursor.y;
          },
        });
      } else {
        pdf.text("No material data available.", 40, materialTableY + 20);
      }

      // === PR Approval Table ===
      pdf.setFont("times", "bold");
      pdf.setFontSize(14);
      pdf.text("PR Approval Status:", 40, tableEndY + 30);

      const approvalColumns = [
        "City",
        "Site",
        "Approver",
        "Role",
        "Status",
        "Sent For Approval",
        "Approved Date",
        "Approval Time",
      ];

      const approvalRows = parsedData1.map((data) => [
        data.city_name || "N/A",
        data.site_name || "N/A",
        data.pr_approval_by || "N/A",
        (Array.isArray(data.pr_approval_by_role)
          ? data.pr_approval_by_role.map((role) => role.role_name)
          : ["N/A"]
        ).join(", "),
        data.pr_status || "Pending",
        data.pr_sent_for_approval_date || "-",
        data.pr_approval_date || "-",
        data.approval_time || "-",
      ]);

      if (approvalRows.length) {
        pdf.autoTable({
          head: [approvalColumns],
          body: approvalRows,
          startY: tableEndY + 45,
          theme: "grid",
          styles: {
            fontSize: 9,
            halign: "center",
            textColor: [0, 0, 0],
            cellPadding: 4,
          },
          headStyles: {
            fillColor: [255, 255, 255],
            textColor: [0, 0, 0],
            fontStyle: "bold",
            lineWidth: 0.5,
          },
          alternateRowStyles: {
            fillColor: [255, 255, 255],
          },
        });
      } else {
        pdf.text("No approval data available.", 40, tableEndY + 50);
      }

      // === Footer with Page Numbers ===
      const totalPages = pdf.internal.getNumberOfPages();
      for (let i = 1; i <= totalPages; i++) {
        pdf.setPage(i);
        pdf.setFontSize(10);
        pdf.setTextColor(100);
        pdf.text(
          `Page ${i} of ${totalPages}`,
          pdf.internal.pageSize.width - 80,
          pdf.internal.pageSize.height - 30
        );
      }

      pdf.save(`purchase_requisition_${pr}.pdf`);
    } catch (error) {
      console.error("Error downloading PR:", error);
    }
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = (pr) => {
    setSelectedPrNumber(pr);
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("purchase-requisition-archive/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(
          t("purchase_requisition_history_archive_successfully1")
        );
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_delete_purchase_requisition_history"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const handleHover = (prNumber) => {
    if (selectedPrNumber !== prNumber) {
      setSelectedPrNumber(prNumber);
    }
    setDotLoaded(false);
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree_name",
      sorter: true,
    },
    {
      title: "PR Number",
      dataIndex: "pr_number",
      key: "pr_number",
      sorter: true,
    },
    {
      title: "PR Created Date",
      dataIndex: "pr_created_date",
      key: "pr_created_date",
      sorter: true,
    },
    {
      title: "PR Creator",
      dataIndex: "pr_creator",
      key: "pr_creator",
      sorter: true,
      // width: 150,
      render: (text, record) => {
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "max-content",
            }}
          >
            <p>{text} </p>
            <p style={{ marginTop: "4px" }}>
              <Tooltip
                color="#094E8F"
                placement="bottom"
                title={
                  <div
                    style={{
                      color: "white",
                      textAlign: "left",
                      padding: "8px 5px",
                    }}
                  >
                    <p style={{ margin: 0, color: "white" }}>
                      <strong>Email:</strong>{" "}
                      {record?.pr_creator_email
                        ? record?.pr_creator_email
                        : "N/A"}
                    </p>
                    <p style={{ margin: 0, color: "white" }}>
                      <strong>Mobile:</strong>{" "}
                      {record?.pr_creator_phone
                        ? record?.pr_creator_phone?.startsWith("91")
                          ? ` +91 ${record?.pr_creator_phone.slice(2)}`
                          : ` ${record?.pr_creator_phone}`
                        : " N/A"}
                    </p>
                  </div>
                }
              >
                <InfoCircleOutlined
                  style={{
                    color: "#094E8F",
                    marginLeft: "3px",
                    cursor: "pointer",
                  }}
                />
              </Tooltip>
            </p>
          </div>
        );
      },
    },
    {
      title: "Approver",
      dataIndex: "pr_approval_by",
      key: "pr_approval_by",
      sorter: true,
      render: (value, record) => {
        const email = record.pr_approval_by_email || "N/A";
        const phone = record.pr_approval_by_phone || "N/A";

        return (
          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <span>{value && value.trim() !== "" ? value : "Rejected"}</span>
            <Tooltip
              color="#094E8F"
              placement="bottom"
              title={
                <>
                  <div>
                    <strong>Email:</strong> {email}
                  </div>
                  <div>
                    <strong>Phone:</strong> {phone}
                  </div>
                </>
              }
            >
              <InfoCircleOutlined
                style={{
                  color: "#094E8F",
                  marginLeft: "3px",
                  cursor: "pointer",
                }}
              />
            </Tooltip>
          </div>
        );
      },
    },

    {
      title: "PR Status",
      dataIndex: "pr_status",
      key: "pr_status",
      sorter: true,
      // width: 180,
      render: (_, record) => {
        const isRejected = record.pr_status === "Reject";
        const rejectByName = record.pr_reject_by || "N/A";

        return (
          <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
            {record.pr_status}
            {isRejected && record.pr_reject_reason && (
              <Tooltip
                color="#094E8F"
                placement="left"
                title={
                  <>
                    <div>
                      <strong>Name: </strong> {rejectByName}
                    </div>
                    <div>
                      <strong>Reason: </strong> {record.pr_reject_reason}
                    </div>
                  </>
                }
              >
                <InfoCircleOutlined
                  style={{ color: "#faad14", cursor: "pointer" }}
                />
              </Tooltip>
            )}
          </span>
        );
      },
    },
    {
      title: "RFQ Status",
      dataIndex: "pr_status_for_rfq",
      key: "pr_status_for_rfq",
      sorter: true,
      width: 250,
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      render: (record) => {
        return (
          <Space>
            <Popover
              placement="left"
              content={
                <DotStatus
                  prNumber={selectedPrNumber}
                  CompanyID={CompanyID}
                  prID={record.id}
                  setDotLoaded={setDotLoaded}
                />
              }
              title={`Status Of PR Number: ${selectedPrNumber}`}
            >
              <ClockCircleOutlined
                onMouseEnter={() => handleHover(record.pr_number)}
                style={{ cursor: "pointer" }}
              />
            </Popover>

            <Popover
              placement="left"
              content={
                <SiteApprovalDotStatus
                  prNumber={selectedPrNumber}
                  CompanyID={CompanyID}
                  prID={record.id}
                  setDotLoaded={setDotLoaded}
                />
              }
              title={`Approval Status Of PR Number: ${selectedPrNumber}`}
            >
              <PieChartOutlined
                onMouseEnter={() => handleHover(record.pr_number)}
                style={{ cursor: "pointer" }}
              />
            </Popover>

            <Tooltip title="View PR">
              <Link to={`/purchase-requisition/details/${record.id}`}>
                <EyeOutlined />
              </Link>
            </Tooltip>
            <Tooltip title="Download PR">
              {record?.category_tree_name?.toLowerCase()?.includes("steel") ? (
                <DownloadOutlined
                  onClick={() =>
                    handleDownloadForSteel(record.id, record.pr_number)
                  }
                />
              ) : (
                <DownloadOutlined
                  onClick={() => handleDownload(record.id, record.pr_number)}
                />
              )}
            </Tooltip>

            {authUserData()?.permission.includes(
              "purchase_requisition|delete_purchaserequisitionmaster"
            ) &&
              isCompanyAdmin !== hasCompanyRole && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleArchive(record.id)}
                >
                  <Tooltip title="Archive PR">
                    <Archive style={{ cursor: "pointer" }} />
                  </Tooltip>
                </Popconfirm>
              )}
          </Space>
        );
      },
    },
  ];

  const expandedRowRender = (materialTypeName, index) => {
    const columns = [
      {
        title: "RFQ Number",
        key: "rfq_number",
        dataIndex: "rfq_number",
      },
      {
        title: "PO Number",
        key: "po_number",
        dataIndex: "po_number",
      },
      {
        title: "PO Site",
        dataIndex: "po_site_name",
        key: "po_site_name",
      },
      {
        title: "PO Date",
        dataIndex: "po_created_date",
        key: "po_created_date",
      },
      {
        title: "Vendor",
        dataIndex: "vendor_name",
        key: "vendor_name",
      },
      {
        title: "Action",
        key: "operation",
        fixed: "right",
        width: 100,
        render: (record) => {
          return (
            <Space>
              <Tooltip title="View Purchase Order By Site">
                <Link
                  target="_blank"
                  to={`/purchase-order/${record.id}/view/${record.po_site_name}`}
                >
                  {pODataId !== null && <EyeOutlined />}
                </Link>
              </Tooltip>
            </Space>
          );
        },
      },
    ];

    return (
      <Table
        className="subtbl"
        columns={columns}
        dataSource={zoneList}
        pagination={false}
      />
    );
  };

  const getZoneList = async (id) => {
    setLoading(true);
    try {
      let apiResponse = await getRequest(
        `po-order/${id}/po-by-purchase-requisition/`
      );

      if (apiResponse?.status) {
        setZoneList(apiResponse?.data?.data);
        setPODataId(apiResponse?.data?.data[0].id);
      } else {
        ErrorNotificationMsg(t("error_in_company_address_list"));
      }
    } catch (error) {
      console.error("Error fetching approval data:", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    const initializeFilters = () => {
      const startDate = formatDate(getPastDate(dayMapping["5D"]));
      const endDate = formatDate(new Date());

      setState((prevState) => ({
        ...prevState,
        pr_created_date__gte: startDate,
        pr_created_date__lte: endDate,
      }));
    };

    initializeFilters();
  }, []);

  useEffect(() => {
    const getPurchaseRequisitionList = async () => {
      setLoading(true);

      try {
        const dependentFields = {
          pr_creator: ["pr_creator_email", "pr_creator_phone"],
          pr_approval_by: ["pr_approval_by_email", "pr_approval_by_phone"],
        };
        const fields = [
          ...new Set([
            "id",
            ...checkedList.filter((key) => key !== "operation"),
            ...checkedList.flatMap((key) => dependentFields[key] || []),
          ]),
        ].join(",");

        let apiResponse = await getRequest(
          `purchase-requisition/?company_id=${CompanyID}&fields=${fields}`,
          state
        );

        if (apiResponse.data.results.success) {
          setPurchaseRequisitionHistory(apiResponse.data.results.data);
          const categoryId = apiResponse.data.results.data.map((item) => ({
            categoryId: item.category_tree,
          }));
          setTotalRequest(apiResponse.data.count);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_material_type"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        ErrorNotificationMsg(t("error_fetching_purchase_requisition"));
      }
    };

    if (
      (state.pr_created_date__gte !== undefined &&
        state.pr_created_date__lte !== undefined) ||
      state.search
    ) {
      getPurchaseRequisitionList();
    }
  }, [state, t, reload, checkedList]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
    setSelectedRow(selectedRow);
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "pr_number" && sortOrder === "ascend") {
      sortingEnumKey = "pr_number";
    }
    if (sortField === "pr_number" && sortOrder === "descend") {
      sortingEnumKey = "-pr_number";
    }
    if (sortField === "pr_created_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_created_date";
    }
    if (sortField === "pr_created_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_created_date";
    }
    if (sortField === "pr_status" && sortOrder === "ascend") {
      sortingEnumKey = "pr_status";
    }
    if (sortField === "pr_status" && sortOrder === "descend") {
      sortingEnumKey = "-pr_status";
    }
    if (sortField === "pr_approval_date" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_date";
    }
    if (sortField === "pr_approval_date" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_date";
    }
    if (sortField === "po_order_placed" && sortOrder === "ascend") {
      sortingEnumKey = "po_order_placed";
    }
    if (sortField === "po_order_placed" && sortOrder === "descend") {
      sortingEnumKey = "-po_order_placed";
    }
    if (sortField === "po_delivery_status" && sortOrder === "ascend") {
      sortingEnumKey = "po_delivery_status";
    }
    if (sortField === "po_delivery_status" && sortOrder === "descend") {
      sortingEnumKey = "-po_delivery_status";
    }
    if (sortField === "pr_assign_by_employee" && sortOrder === "ascend") {
      sortingEnumKey = "pr_assign_by_employee";
    }
    if (sortField === "pr_assign_by_employee" && sortOrder === "descend") {
      sortingEnumKey = "-pr_assign_by_employee";
    }
    if (sortField === "pr_type" && sortOrder === "ascend") {
      sortingEnumKey = "pr_type";
    }
    if (sortField === "pr_type" && sortOrder === "descend") {
      sortingEnumKey = "-pr_type";
    }
    if (sortField === "pr_creator" && sortOrder === "ascend") {
      sortingEnumKey = "pr_creator";
    }
    if (sortField === "pr_creator" && sortOrder === "descend") {
      sortingEnumKey = "-pr_creator";
    }
    if (sortField === "company" && sortOrder === "ascend") {
      sortingEnumKey = "company";
    }
    if (sortField === "company" && sortOrder === "descend") {
      sortingEnumKey = "-company";
    }
    if (sortField === "pr_approval_by" && sortOrder === "ascend") {
      sortingEnumKey = "pr_approval_by";
    }
    if (sortField === "pr_approval_by" && sortOrder === "descend") {
      sortingEnumKey = "-pr_approval_by";
    }
    return sortingEnumKey;
  };

  const handleReset = () => {
    setSelectedCard(null);
    setClickedFilterButton(false);
    setPoOrderPlaced("");
    setPrStatus("");
    setStartDate("");
    setEndDate("");
    setSelectedFilter("All");
    setState((prevState) => {
      const {
        pr_created_date__gte,
        pr_created_date__lte,
        pr_status,
        search,
        ...rest
      } = prevState;
      return {
        ...rest,
        page: 1,
        pagesize: 10,
        ordering: "id",
        pr_created_date__gte: "",
        pr_created_date__lte: "",
      };
    });
    formRef.current.setFieldsValue({
      pr_created_date__gte: null,
      pr_status: null,
      po_order_placed: null,
      pr_created_date__lte: null,
    });
  };
  const handleClearFields = () => {
    setStartDate("");
    setEndDate("");
  };

  const handleClickCard = (value) => {
    setSelectedCard(value);
    setPoOrderPlaced("");
    setPrStatus("");
    // Do NOT reset startDate, endDate, selectedFilter, or form fields here
    setState((prevState) => {
      let newState;

      if (value === "PR Assigned") {
        newState = {
          ...prevState,
          pr_status: "",
          pr_status_for_rfq: value || "",
          // Do not reset date filters
          search: "",
          page: 1,
          pagesize: 10,
        };
      } else if (
        Array.isArray(value) &&
        value.includes("Rejected") &&
        value.includes("Reject With Reason")
      ) {
        newState = {
          ...prevState,
          pr_status: "Rejected,Reject With Reason",
          pr_status_for_rfq: "",
          // Do not reset date filters
          search: "",
          page: 1,
          pagesize: 10,
        };
      } else {
        newState = {
          ...prevState,
          pr_status: value || "",
          pr_status_for_rfq: "",
          // Do not reset date filters
          search: "",
          page: 1,
          pagesize: 10,
        };
      }
      return JSON.stringify(prevState) === JSON.stringify(newState)
        ? { ...newState }
        : newState;
    });
  };

  const rowSelection = {
    onSelect: (record, selected, selectedRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, record.id]
        : selectedRow.filter((key) => key !== record.id);
      setSelectedRow(updatedSelectedRowKeys);
    },
    onSelectAll: (selected, selectedRows, changeRows) => {
      const updatedSelectedRowKeys = selected
        ? [...selectedRow, ...changeRows.map((row) => row.id)]
        : selectedRow.filter(
            (key) => !changeRows.find((row) => row.id === key)
          );
      setSelectedRow(updatedSelectedRowKeys);
    },
    selectedRowKeys: selectedRow,
  };
  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setSelectedFilter("All");

    if (value) {
      setState((prevState) => {
        const {
          pr_created_date__gte,
          pr_created_date__lte,
          pr_status,
          ...rest
        } = prevState;

        return {
          ...rest,
          search: value,
        };
      });
    } else {
      setState((prevState) => {
        const { pr_created_date__gte, pr_created_date__lte, search, ...rest } =
          prevState;
        return {
          ...rest,
        };
      });
    }
  };
  const handleExpand = async (expanded, record) => {
    if (expanded) {
      setZoneList([]);
      await getZoneList(record.id);
      setExpandedRowKeys([record.id]);
    } else {
      setExpandedRowKeys([]);
    }
  };

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  const filteredColumns = columns.filter((column) =>
    checkedList.includes(column.key)
  );

  const columnMenu = (
    <Menu
      className="packagelistdropdown"
      style={{ width: "450px", padding: "10px", borderRadius: "8px" }}
    >
      <Menu.Item key="columnMenu">
        <Checkbox.Group
          value={checkedList}
          onChange={handleColumnVisibilityChange}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Row style={{ width: "100%" }}>
            {columns.map((column) => (
              <Col span={12} key={column.key}>
                <Checkbox
                  value={column.key}
                  disabled={column.key === "operation"}
                >
                  {column.title}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>Purchase Requisition (PR) - History</h3>
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">Dashboard</Link>
              </Breadcrumb.Item>

              <Breadcrumb.Item>
                Purchase Requisition (PR) - History
              </Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <Space>
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                  value={state.search}
                />
              </Space>
            </div>
            {authUserData()?.permission.includes(
              "purchase_requisition|delete_purchaserequisitionmaster"
            ) &&
              isCompanyAdmin !== hasCompanyRole &&
              selectedRow.length > 0 && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleArchive()}
                >
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_Archive")}
                  />
                </Popconfirm>
              )}
            {authUserData()?.permission.includes(
              "purchase_requisition|delete_purchaserequisitionmaster"
            ) &&
              isCompanyAdmin !== hasCompanyRole && (
                <Tooltip placement="topLeft" title="Archived Records">
                  <Link to="/purchase-requisition/archive">
                    <Archiveicon />
                  </Link>
                </Tooltip>
              )}
          </Space>
        </div>
      </div>

      <section className="grid-sec mt-5 tablegridsec">
        <div className="PR-body">
          {
          <SubscriptionNotification />
        }
          <section
            className="Block-Sec-Demo1 mb-5"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Row gutter={[15]}>
              {[
                {
                  status: "",
                  title: "Total PR",
                  count: statusCounts.total_count,
                  icon: TotalCount,
                },
                {
                  status: "Pending",
                  title: "Pending For Approval",
                  count: statusCounts.pending_for_approval_count,
                  icon: PendingActions,
                },
                {
                  status: "Approved",
                  title: "Approved",
                  count: statusCounts.approve_count,
                  icon: OrderApprove,
                },
                {
                  status: ["Rejected", "Reject With Reason"],
                  title: "Rejected",
                  count: statusCounts.reject_count,
                  icon: rejectedIcon,
                },
                {
                  status: "PR Assigned",
                  title: "RFQ Yet To Be Floated",
                  count: statusCounts.rfq_to_be_floted_count,
                  icon: arrow1,
                },
              ].map((item, index) => {
                if (item.status.includes("Rejected", "Reject With Reason")) {
                  return (
                    <Col key={index}>
                      <div
                        className={`card ${
                          selectedCard && selectedCard[0] === "Rejected"
                            ? item.status
                              ? "active"
                              : ""
                            : ""
                        }`}
                        onClick={() => handleClickCard(item.status)}
                        style={{
                          width: "fit-content",
                        }}
                      >
                        <div className="card-block">
                          <div className="card-box">
                            <div className="card-icon">
                              <img
                                src={item.icon}
                                alt={item.title}
                                width={35}
                              />
                            </div>
                            <div className="card-description">
                              <h3>{item.title}</h3>
                              <p>{item.count}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                } else {
                  return (
                    <Col key={index}>
                      <div
                        className={`card ${
                          selectedCard === item.status ? "active" : ""
                        }`}
                        onClick={() => handleClickCard(item.status)}
                        style={{
                          width: "fit-content",
                        }}
                      >
                        <div className="card-block">
                          <div className="card-box">
                            <div className="card-icon">
                              <img
                                src={item.icon}
                                alt={item.title}
                                width={35}
                              />
                            </div>
                            <div className="card-description">
                              <h3>{item.title}</h3>
                              <p>{item.count}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  );
                }
              })}
            </Row>
            <div className="btnscol">
              {authUserData()?.permission.includes(
                "purchase_requisition|add_purchaserequisitionmaster"
              ) &&
                !isCompanyAdmin && (
                  <ButtonField
                    className="SaveGradiantBtn"
                    type="primary"
                    htmlType="Apply"
                    label="Add New PR"
                    onClick={() => navigate("/create-pr")}
                  />
                )}
            </div>
          </section>

          <div className="filterrow">
            <div className="filtercol">
              <Form autoComplete="off" ref={formRef}>
                <Space wrap>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="pr_created_date__gte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select Start Date"
                        value={startDate}
                        onChange={handleStartDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="pr_created_date__lte">
                      <DatePicker
                        format="DD-MM-YY"
                        placeholder="Select End Date"
                        value={endDate}
                        onChange={handleEndDateChange}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} className="TextFeild gutter-row">
                    <Form.Item name="category_id">
                      <Select
                        // showSearch
                        allowClear
                        placeholder={
                          t("pl_select_category") || "Select Category"
                        }
                        value={categoryTreeFilter}
                        onChange={handleCategoryChange}
                        style={{ minWidth: 180 }}
                        optionFilterProp="children"
                      >
                        {categoryTree.map((cat) => (
                          <Select.Option key={cat.id} value={cat.id}>
                            {cat.name}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>

                  <>
                    <Button
                      type="primary"
                      htmlType="Apply"
                      icon={
                        <Tooltip title="Apply" color="#094E8F">
                          <FilterOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                      }}
                      onClick={
                        startDate || endDate || categoryTreeFilter
                          ? handleApplyFilter
                          : null
                      }
                    />
                    <Button
                      type="primary"
                      htmlType="Reset"
                      icon={
                        <Tooltip title="Reset" color="#094E8F">
                          <UndoOutlined style={{ fontSize: "20px" }} />
                        </Tooltip>
                      }
                      style={{
                        backgroundColor: "#094e8f",
                        color: "#ffffff",
                        border: "none",
                        width: "40px",
                        height: "40px",
                        boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                        borderRadius: "4px",
                      }}
                      onClick={
                        clickedFilterButton ? handleReset : handleClearFields
                      }
                    />
                  </>
                </Space>
              </Form>
            </div>
            <div className="btnscol">
              <Space>
                <h5 style={{ color: "#094E8F", display: "flex", margin: "0" }}>
                  <Tooltip
                    color="#094E8F"
                    title={"PR filter by number of days / month"}
                  >
                    Last:
                  </Tooltip>
                  <span className="rfq-number new">
                    {filterDate.map((item, index) => (
                      <span
                        key={index}
                        style={{
                          backgroundColor: selectedFilter === item && "white",
                          margin: "0 5px",
                          padding: "8px 18px",
                          cursor: "pointer",
                          fontWeight:
                            selectedFilter === item ? "bold" : "normal",
                          color: selectedFilter === item ? "black" : "black",
                          border:
                            selectedFilter === item
                              ? "0.5px solid rgb(154, 165, 177)"
                              : "none",
                          boxShadow:
                            selectedFilter === item
                              ? "-1px 1px 5px 2px rgba(56,135,201,0.75)"
                              : "none",
                          transition: "box-shadow 0.3s ease-in-out",
                        }}
                        onClick={() => {
                          setSelectedFilter(item);
                          applyFilter(item);
                          setSelectedCard(null);
                        }}
                      >
                        {item}
                      </span>
                    ))}
                  </span>
                </h5>

                <ButtonField
                  className="SaveGradiantBtn"
                  type="primary"
                  htmlType="Refresh"
                  label="Refresh"
                  onClick={handleRefresh}
                  icon={<img src={RefreshIcon} alt="Refresh Icon" />}
                />
                <div>
                  <Dropdown
                    overlay={columnMenu}
                    trigger={["hover"]}
                    placement="bottomRight"
                    visible={dropdownVisible}
                    onVisibleChange={setDropdownVisible}
                  >
                    <Tooltip
                      title="Modify Columns"
                      placement="topLeft"
                      color="#094E8F"
                    >
                      <Button
                        className="SaveGradiantBtn"
                        type="primary"
                        icon={<ColumnList />}
                        style={{ minWidth: "36px" }}
                      />
                    </Tooltip>
                  </Dropdown>
                </div>
              </Space>
            </div>
          </div>
          <div className="tablewrp">
            <Table
              scroll={{
                x: 1050,
              }}
              columns={filteredColumns}
              rowSelection={rowSelection}
              rowKey={(record) => record.id}
              dataSource={purchaseRequisitionHistory}
              loading={loading}
              pagination={{
                current: state.page,
                pageSize: state.pagesize,
                defaultCurrent: state.page,
                defaultPageSize: state.pagesize,
                total: totalCount,
                showTotal: (total) => `Total ${total} items`,
                showSizeChanger: true,
                locale: {
                  items_per_page: "Items / Page",
                },
              }}
              onChange={handleTableChange}
              expandable={{
                expandedRowRender,
                onExpand: handleExpand,
                expandedRowKeys,
              }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default PurchaseRequisitionHistory;
